import { render, staticRenderFns } from "./MarketingTools.vue?vue&type=template&id=b82b4824"
import script from "./MarketingTools.vue?vue&type=script&lang=js"
export * from "./MarketingTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports